define("shared/components/shared/locale", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "later/utils/constants", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _constants, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"later/utils/constants",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="u--row">
    <div class="u--col__4">
      <h5
        class="u--text--md u--m__t__0 qa--displaySettings_language_title"
        data-test-id="calendar-settings-timezone-title"
      >
        {{t "calendar.settings.locale_title"}}
        <Shared::Badge @className="cVL--badge--sm is--beta" />
      </h5>
    </div>
    <div class="u--col__8">
      <form class="o--formWrapper u--m__b__sm">
        <select class="o--form__select" {{on "change" this.setLocale}}>
          {{#each this.locale.enabledLocales as |locale|}}
            <option selected={{are-equal locale.code this.currentLocale}} value={{locale.code}}>
              {{locale.name}}
            </option>
          {{/each}}
        </select>
      </form>
      <p class="u--text--light u--m__b__lg">{{t "calendar.settings.locale_detail"}}</p>
    </div>
  </div>
  */
  {
    "id": "fOLqqgmy",
    "block": "[[[10,0],[14,0,\"u--row\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"u--col__4\"],[12],[1,\"\\n    \"],[10,\"h5\"],[14,0,\"u--text--md u--m__t__0 qa--displaySettings_language_title\"],[14,\"data-test-id\",\"calendar-settings-timezone-title\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"calendar.settings.locale_title\"],null]],[1,\"\\n      \"],[8,[39,1],null,[[\"@className\"],[\"cVL--badge--sm is--beta\"]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"u--col__8\"],[12],[1,\"\\n    \"],[10,\"form\"],[14,0,\"o--formWrapper u--m__b__sm\"],[12],[1,\"\\n      \"],[11,\"select\"],[24,0,\"o--form__select\"],[4,[38,2],[\"change\",[30,0,[\"setLocale\"]]],null],[12],[1,\"\\n\"],[42,[28,[37,4],[[28,[37,4],[[30,0,[\"locale\",\"enabledLocales\"]]],null]],null],null,[[[1,\"          \"],[10,\"option\"],[15,\"selected\",[28,[37,5],[[30,1,[\"code\"]],[30,0,[\"currentLocale\"]]],null]],[15,2,[30,1,[\"code\"]]],[12],[1,\"\\n            \"],[1,[30,1,[\"name\"]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[1]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--text--light u--m__b__lg\"],[12],[1,[28,[35,0],[\"calendar.settings.locale_detail\"],null]],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"locale\"],false,[\"t\",\"shared/badge\",\"on\",\"each\",\"-track-array\",\"are-equal\"]]",
    "moduleName": "shared/components/shared/locale.hbs",
    "isStrictMode": false
  });
  let LocaleComponent = _exports.default = (_class = class LocaleComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "cache", _descriptor2, this);
      _initializerDefineProperty(this, "errors", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      _initializerDefineProperty(this, "locale", _descriptor5, this);
      _initializerDefineProperty(this, "router", _descriptor6, this);
      _initializerDefineProperty(this, "segment", _descriptor7, this);
    }
    get currentLocale() {
      return this.intl.primaryLocale;
    }
    get formattedLocale() {
      return new Intl.Locale(this.currentLocale, {});
    }
    get buttonLocation() {
      if (this.router.currentRouteName.includes('calendar')) {
        return 'calendar settings';
      }
      if (this.router.currentRouteName.includes('account')) {
        return 'account settings';
      }
      return 'unknown';
    }
    get cacheKey() {
      return _constants.LOCALE_CACHE_KEY + '_' + this.auth.currentUserModel?.id;
    }
    async setLocale(_ref) {
      let {
        target: {
          value
        }
      } = _ref;
      try {
        const languageNames = new Intl.DisplayNames('en-us', {
          type: 'language',
          style: 'long'
        });
        const previous_language = this.intl.primaryLocale;
        await this.locale.setUserLanguage(value);
        await this.locale.setLanguage(value);
        this.cache.add(this.cacheKey, value, {
          expiry: this.cache.maxExpiryDate(),
          persist: true
        });
        this.segment.track('changed-language', {
          selected_language: languageNames.of(value),
          previous_language: languageNames.of(previous_language),
          changed_language: value !== previous_language,
          button_location: this.buttonLocation
        });
      } catch (error) {
        this.errors.log(error);
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "locale", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "setLocale", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setLocale"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, LocaleComponent);
});